import { defineRouting } from "next-intl/routing"
import { locales, defaultLocale } from "./config"

export const routing = defineRouting({
  locales,
  defaultLocale,
  // The default locale is served unprefixed (`/`, `/products/…`); every other
  // locale keeps its prefix (`/en`, `/en/products/…`).
  localePrefix: "as-needed",
})
